import React from 'react';
import PropTypes from 'prop-types';

const DEFAULT_ERROR_TEXT = 'Something went wrong loading the dashboard.';

export const DashboardError = ({ message, onRetry }) => (
    <div className="dashboard__overlay">
        <p className="dashboard__error-text">{message || DEFAULT_ERROR_TEXT}</p>
        <button className="dashboard__retry-btn" onClick={onRetry}>Retry</button>
    </div>
);

DashboardError.propTypes = {
    message: PropTypes.string,
    onRetry: PropTypes.func.isRequired,
};
